import { useTranslation } from 'react-i18next'
import {
  faLinkSimpleSlash,
  faThumbsUp,
} from '@fortawesome/pro-regular-svg-icons'
import { Label } from 'components/indicators/label'

export const LinkedStatus = ({ linked }: { linked: boolean }) => {
  const { t } = useTranslation()

  return (
    <Label
      className="max-w-[120px]"
      color={linked ? 'success' : 'neutral'}
      icon={linked ? faThumbsUp : faLinkSimpleSlash}
    >
      {linked ? t('common.linked') : t('common.unlinked')}
    </Label>
  )
}
